import DeudaListCustom from './DeudaListCustom'
export {DeudaListCustom}
export default DeudaListCustom
